import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'marketing/targets',
    name: 'MarketingTargets',
    component: () => import('@/pages/marketing-targets/TargetList.vue'),
    meta: { title: '目标管理', parent: '营销管理' },
  },
  {
    path: 'marketing/targets/create',
    name: 'MarketingTargetCreate',
    component: () => import('@/pages/marketing-targets/TargetCreateBasic.vue'),
    meta: { title: '制定目标', parent: '目标管理' },
  },
  {
    path: 'marketing/targets/create/decompose',
    name: 'MarketingTargetDecompose',
    component: () => import('@/pages/marketing-targets/TargetDecompose.vue'),
    meta: { title: '目标拆解', parent: '目标管理' },
  },
  {
    path: 'marketing/targets/:targetId/result',
    name: 'MarketingTargetResult',
    component: () => import('@/pages/marketing-targets/TargetDetailResult.vue'),
    meta: { title: '考核结果', parent: '目标管理' },
  },
  {
    path: 'marketing/targets/:targetId',
    name: 'MarketingTargetDetail',
    component: () => import('@/pages/marketing-targets/TargetDetailProgress.vue'),
    meta: { title: '目标详情', parent: '目标管理' },
  },
]

export default routes
